import { EntidadeBase } from 'hay-core-react';
class TemplateConfiguracaoModel extends EntidadeBase {
  constructor() {
    super('templateconfiguracao');
  }
}

export default new TemplateConfiguracaoModel();
